const Setlightbox = (thiss, gantt) => {
  //console.log("DATA", gantt);
  //console.log("DATA thiss", thiss)
  gantt.locale.labels.section_description = "Descripción";
  gantt.locale.labels.section_owner = "Responsable";
  gantt.locale.labels.section_progress = "Progreso";
  gantt.locale.labels.section_tipo = "Tipo";
  gantt.locale.labels.section_details = "Detalles";
  gantt.locale.labels.section_evidence = "";
  gantt.locale.labels.section_date = "Date";
  gantt.locale.labels.section_type = "Perspectiva";
  gantt.locale.labels["gantt_complete_btn"] = "Aprobado";

  gantt.config.buttons_left = ["gantt_delete_btn", "gantt_cancel_btn"];
  gantt.config.buttons_right = ["gantt_save_btn", "gantt_complete_btn"];

  gantt.config.lightbox.sections = [
    {
      name: "description",
      height: 38,
      map_to: "text",
      type: "textarea",
      focus: true
    },
    {
      name: "details",
      height: 68,
      map_to: "details",
      type: "textarea",
      focus: true
    },
    {
      name: "owner",
      height: 22,
      map_to: "owner_id",
      type: "select",
      options: thiss.employeesList
    },
    {
      name: "progress",
      height: 22,
      map_to: "progress",
      type: "select",
      options: thiss.listProgress
    },
    {
      name: "type",
      height: 22,
      map_to: "type",
      type: "select",
      options: [
        { key: 1, label: "Financiera" },
        { key: 2, label: "Del cliente" },
        { key: 3, label: "Procesos internos" },
        { key: 4, label: "Desarrollo y Aprendizaje" }
      ]
    },
    {
      name: "tipo",
      height: 22,
      map_to: "type_strategic",
      type: "select",
      options: [
        { key: 1, label: "Operacional" },
        { key: 2, label: "Estrátegico" }
      ]
      // thiss.currentUser.EmployeeId == 37
      //   ? [
      //       { key: 1, label: "Operacional" },
      //       { key: 2, label: "Estrátegico" }
      //     ]
      //   : [{ key: 1, label: "Operacional" }]
    },
    {
      name: "evidence",
      height: 22,
      map_to: "evidence",
      type: "template"
    },
    // {name:"date", height:72, type:"time", map_to:"auto"},
    {
      name: "time",
      type: "duration",
      map_to: "auto"
    }
  ];

  gantt.config.resource_store = "resource";
  gantt.config.resource_property = "owner_id";
  gantt.config.order_branch = true;
  gantt.config.open_tree_initially = true;

  var resourcesStore = gantt.createDatastore({
    name: gantt.config.resource_store,
    type: "treeDatastore",
    initItem: function (item) {
      item.parent = item.parent || gantt.config.root_id;
      item[gantt.config.resource_property] = item.parent;
      item.open = true;
      return item;
    }
  });

  resourcesStore.attachEvent("onParse", function () {
    var people = [];
    resourcesStore.eachItem(function (res) {
      if (!resourcesStore.hasChild(res.id)) {
        var copy = gantt.copy(res);
        copy.key = res.id;
        copy.label = res.text;
        people.push(copy);
      }
    });
    gantt.updateCollection("people", people);
  });

  resourcesStore.parse(thiss.listOwners);
};

export default Setlightbox;
